// extracted by mini-css-extract-plugin
export default {"spinning-container":"src-components-list-styles_spinning-container","spinningContainer":"src-components-list-styles_spinning-container"};